import React from "react";
import styled from "styled-components";

import { useTheme } from "../ThemeContext";
import { ThemeType } from "../theme/Theme";

// eslint-disable-next-line
export enum FontSize {
  xxl = "var(--atira-font-size-heading-xl)",
  xl = "var(--atira-font-size-heading)",
  l = "var(--atira-font-size-sub-heading)",
  m = "var(--atira-font-size-body)",
  s = "var(--atira-font-size-small)",
  xs = "var(--atira-font-size-note)",
}

export enum LineHeight {
  xxl = "1.1",
  xl = "1.3",
  l = "1.3",
  m = "1.5",
  s = "1.4",
  xs = "1.3",
}

// eslint-disable-next-line
enum Alignment {
  start = "start",
  center = "center",
  end = "end",
}

export interface ParagraphProps {
  fontSize?: keyof typeof FontSize;
  children?: React.ReactNode;
  color?: keyof ThemeType;
  align?: keyof typeof Alignment;
  textDecoration?: React.CSSProperties["textDecoration"];
  fontWeight?: React.CSSProperties["fontWeight"];
  cutText?: boolean;
  style?: React.CSSProperties;
  wordBreak?: React.CSSProperties["wordBreak"];
  direction?: React.CSSProperties["direction"];
  dir?: React.HTMLAttributes<HTMLParagraphElement>["dir"];
  lineHeight?: React.CSSProperties["lineHeight"];
  className?: string;
  onMouseEnter?: React.MouseEventHandler<HTMLParagraphElement>;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
  as?: React.ElementType;
}

const P = styled.p<ParagraphProps>`
  font-size: ${(props) => FontSize[props.fontSize || "m"]};
  color: ${(props) =>
    props.color ? props.theme[props.color] : props.theme["textColor"]};
  text-align: ${(props) => (props.align ? Alignment[props.align] : "start")};
  text-decoration: ${({ textDecoration }) => textDecoration};
  font-weight: ${({ fontWeight }) => fontWeight};
  text-overflow: ${(props) => (props.cutText ? "ellipsis" : "auto")};
  overflow: ${(props) => (props.cutText ? "hidden" : "visible")};
  word-break: ${(props) => props.wordBreak};
  white-space: ${(props) => (props.cutText ? "nowrap" : "normal")};
  direction: ${({ direction }) => direction || "inherit"};
  line-height: ${({ fontSize, lineHeight }) =>
    lineHeight || LineHeight[fontSize || "m"]};
`;

export const Text: React.FC<ParagraphProps> = (props) => {
  const { theme } = useTheme();
  return <P {...props} theme={theme}></P>;
};
